/**
 * This file contains the maximum length of the text fields.
 * This is used to validate the text fields.
 * @see https://www.notion.so/ikala/Engineering-502b9210ba334022bf96bd13399d1fcd?pvs=4#965c3bc029e34643bc984f6e0bc0f30a
 */
const textMaximumLength = {
  title: 255,
  content: 1000,
} as const

export default textMaximumLength
